module.exports = __webpack_public_path__ + "img/UpdateAssignee.9a769da0.svg";